import React, { useEffect, useRef, useState } from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputReactDatepicker,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4, DEFAULT_VALUE_OPTION, EXCEL_DEFAULT_SEPARATOR } from "App/constants";
import { useSelectOption } from "App/hooks";
import { urlGetProdusen, getByFilterBarang } from ".";
import { CSVLink } from "react-csv";
import { FilterColumns, PrepareDataExportAdvenced } from "App/Component/layout/MasterData/helpers";
import { defaultDateDisplay, defaultToastError } from "App/utils/helpers";
export default function FormFilterGudangUtama({
  formFilter,
  setFormFilter,
  setNewData,
  totalData,
}) {
  const [rowsExport, setRowsExport] = useState([]);
  const [readyExport, setReadyExport] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const csvLink = useRef(null);
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const produsen = useSelectOption(true, urlGetProdusen, TYPE_INSTANCE4);

  const handleExport = async (e) => {
    e.preventDefault();
    setReadyExport(false);
    setIsLoading(true);

    const res = await getByFilterBarang(formFilter, 1, totalData, true);
    if (res.state) {
      setRowsExport(res.data);
      setReadyExport(true);
      setIsLoading(false);
    } else {
      setRowsExport([]);
      setReadyExport(false);
      setIsLoading(false);
      defaultToastError(res.message);
    }
  };

  useEffect(() => {
    if (csvLink && csvLink.current && readyExport) {
      csvLink.current.link.click();
    }
  }, [readyExport]);

  const PrepareHeadersAdvanced = {
    no: {
      key: "no",
      value: (row, i) => i + 1,
    },
    name: {
      key: "nama",
      value: "name",
    },
    id: {
      key: "id",
      value: "id",
    },
    nama_golongan: {
      key: "nama_golongan",
      value: "nama_golongan",
    },
    golongan_id: {
      key: "golongan_id",
      value: "golongan_id",
    },
    qty: {
      key: "qty",
      value: "qty_wl_inv",
    },
    harga_pokok: {
      key: "harga_pokok",
      value: "hargapokok",
    },
    harga_beli: {
      key: "harga_beli",
      value: "hargabeli",
    },
    satuan_beli: {
      key: "satuan_beli",
      value: "satuan_beli",
    },
    satuanbeli_id: {
      key: "satuanbeli_id",
      value: "satuanbeli_id",
    },
    satuan_jual: {
      key: "satuan_jual",
      value: "satuan_jual",
    },
    satuanjual_id: {
      key: "satuanjual_id",
      value: "satuanjual_id",
    },
    produsen_name: {
      key: "produsen",
      value: "produsen_name",
    },
    produsen_id: {
      key: "produsen_id",
      value: "produsen_id",
    },
    is_active: {
      key: "is_active",
      value: "is_active",
    },
    
    INSERTED_TIME: {
      key: "INSERTED_TIME",
      value: (row) => defaultDateDisplay(row?.createdAt),
    },
    INSERTED_BY: {
      key: "INSERTED_BY",
      value: "createdBy",
    },
    UPDATED_TIME: {
      key: "UPDATED_TIME",
      value: (row) => defaultDateDisplay(row?.updatedAt),
    },
    UPDATED_BY: {
      key: "UPDATED_BY",
      value: "updatedBy",
    },
  };

  const dataExport = PrepareDataExportAdvenced(
    rowsExport,
    PrepareHeadersAdvanced
  );
  const headerExport = FilterColumns(dataExport);

  return (
    <>
      <p className='fw-600 mb-2 mt-1'>Daftar Barang Logistik</p>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={2}>
            <InputReactDatepicker
              selected={formFilter.tglAwal}
              label='TANGGAL AWAL'
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
            />
          </Grid>
          <Grid item sm={2}>
            <InputReactDatepicker
              selected={formFilter.tglAkhir}
              label='TANGGAL AKHIR'
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
            />
          </Grid>
          <Grid item sm={2}>
            <InputTextMaster
              name='id'
              label='ID BARANG'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID Barang'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama'
              label='NAMA BARANG'
              id='nama'
              value={formFilter.nama}
              onChange={handleChange("nama")}
              placeholder='Nama Barang'
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='produsen_id'
              label='PRODUSEN'
              id='produsen_id'
              withSearch={true}
              labelValue={formFilter.produsen_name}
              data={
                produsen?.length > 0
                  ? produsen
                  : [DEFAULT_VALUE_OPTION("Produsen")]
              }
              value={formFilter.produsen_id}
              onChange = {(e) => setFormFilter({
                ...formFilter,
                produsen_id : e?.value,
                produsen_name : e?.label,}
              )}
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          style={{
            gap: "1rem",
          }}
          alignItems='center'>
          <MasterButton
            type={"button"}
            color='warning'
            name={isLoading ? "Loading..." : "EXPORT"}
            disabled={isLoading}
            size='md'
            onClick={handleExport}
          />
          <CSVLink
            filename={`Daftar Barang.xls`}
            data={dataExport ?? []}
            headers={headerExport ?? []}
            separator={EXCEL_DEFAULT_SEPARATOR}
            target='_blank'
            ref={csvLink}
            style={{ display: "none" }}></CSVLink>

          <MasterButton
            name={"CARI"}
            type='submit'
            outline={true}
            color={"green"}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
